var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "content-container" },
    [
      _c(
        "h2",
        {
          staticClass: "text-center font-weight-medium pt-10 pb-6",
          class: !_vm.isMobilePort ? "text-h4" : "",
          style: _vm.isMobilePort ? "font-size: 24px" : "",
        },
        [
          _vm._v(
            "\n        Faster compliance with code intelligence tools\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { attrs: { justify: "center", align: "stretch", dense: "" } },
        _vm._l(_vm.tools, function (tool, index) {
          return _c(
            "v-col",
            {
              key: index,
              class: {
                "pr-5": index !== _vm.tools.length - 1 && !_vm.isMobilePort,
              },
              attrs: { cols: "12", sm: "6", md: "3" },
            },
            [
              _c(
                "v-card",
                { staticClass: "pa-4 rounded-lg", attrs: { outlined: "" } },
                [
                  _c(
                    "v-avatar",
                    {
                      staticClass: "rounded",
                      attrs: { size: "56", tile: "", color: "primaryLight" },
                    },
                    [
                      tool.type === "image"
                        ? _c("v-img", {
                            attrs: {
                              height: "40",
                              src: tool.icon,
                              contain: "",
                            },
                          })
                        : _c(
                            "v-icon",
                            { attrs: { size: "40", color: "primary" } },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(tool.icon) +
                                  "\n                    "
                              ),
                            ]
                          ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("h6", { staticClass: "text-h6 font-weight-medium py-4" }, [
                    _vm._v(_vm._s(tool.title)),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-body-1 mb-4" }, [
                    _vm._v(_vm._s(tool.description)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass:
                        "text-body-1 font-weight-medium text-decoration-underline",
                      class: tool.anchorClass,
                      attrs: { href: tool.linkUrl },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(tool.linkText) +
                          "\n                    "
                      ),
                      _c("v-icon", { attrs: { color: "primary" } }, [
                        _vm._v("mdi-chevron-right"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }